var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.enableSignupIntegrated)?_c('SignUp'):_c('SignUpIntegrated')
}
var staticRenderFns = []

export { render, staticRenderFns }